module.exports = {
    urls: {
         api: "api2.intouchnetworks.com"
    },
};


//////////////////
// WEBPACK FOOTER
// ./config/remote/remote.actual.js
// module id = 1412
// module chunks = 0